import { db, SyncManager } from 'db';
import { useLiveQuery } from 'dexie-react-hooks';
import d from 'final-form-arrays';
import { useIsOnline } from 'hooks';
import { useField } from 'react-final-form';
import { useAddCheckboxMutation } from 'services/api/vehicle-sections';
import { generateRandomId } from 'utils/crypto';
import { useFormVehicleId } from './useFormVehicleId';

export const useAddCheckbox = (sectionId: string, fieldName: string) => {
  const [addCheckbox] = useAddCheckboxMutation();
  const isOnline = useIsOnline();

  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const { input: idInput } = useField(`${fieldName}.id`);

  const vehicleId = useFormVehicleId();

  const save = async (label: string, isSelected: boolean, i: number) => {
    if (!vehicleId) return;

    const newCheckboxId = `${serverId}-${i}`;

    const syncManager = SyncManager.getInstance(vehicleId);
    await syncManager.queueEntityUpdate(newCheckboxId, 'new_checkbox', [
      ['selected', isSelected],
      ['label', label]
    ]);
    idInput.onChange(newCheckboxId);
  };

  const saveold = async (label: string, isSelected: boolean, i: number) => {
    if (!vehicleId) return;

    let newId: number | null = null;
    if (isOnline) {
      const response = await addCheckbox({
        vehicleId,
        sectionId: serverId,
        payload: {
          selected: isSelected,
          label
        }
      });

      if ('data' in response) {
        newId = response.data.data.id;
      }
    } else {
      const newCheckboxId = `${serverId}-${i}`;
      await db.entityUpdates.add({
        id: generateRandomId(),
        entityId: newCheckboxId,
        entityType: 'new_checkbox',
        formId: vehicleId,
        key: 'label',
        value: label,
        timestamp: Date.now(),
        synced: false
      });
      await db.entityUpdates.add({
        id: generateRandomId(),
        entityId: newCheckboxId,
        entityType: 'new_checkbox',
        formId: vehicleId,
        key: 'selected',
        value: isSelected,
        timestamp: Date.now(),
        synced: false
      });
    }

    return newId;
  };

  return save;
};
